import React from 'react';
import { Tooltip } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import DeleteTwoToneIcon from '@mui/icons-material/DeleteTwoTone';

interface Props {
  handleDeleteClick: () => void,
}

const DeleteInteraction: React.FC<Props> = ({
  handleDeleteClick,
}) => (
  <Tooltip placement="top" title="Delete Media" arrow>
    <IconButton
      id="composition-button"
      onClick={handleDeleteClick}
    >
      <DeleteTwoToneIcon />
    </IconButton>
  </Tooltip>
);

export default DeleteInteraction;
